const HOUR_MS = 3_600_000;
const HOURS_PER_DAY = 24;

/** The age filter's choices, as `minAgeHours`: "waiting a day or more", and so on. */
export const AGE_FILTER_OPTIONS = [
  { label: '1 day or more', value: 1 * HOURS_PER_DAY },
  { label: '3 days or more', value: 3 * HOURS_PER_DAY },
  { label: '7 days or more', value: 7 * HOURS_PER_DAY },
] as const;

/** How long it has been waiting, from when the server wrote it: "5 hours", "3 days". */
export function waitingFor(serverTime: string, now: Date): string {
  const hours = Math.max(0, Math.floor((now.getTime() - new Date(serverTime).getTime()) / HOUR_MS));
  if (hours < HOURS_PER_DAY) return hours === 1 ? '1 hour' : `${hours} hours`;
  const days = Math.floor(hours / HOURS_PER_DAY);
  return days === 1 ? '1 day' : `${days} days`;
}
